import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, className = "", y = 24 }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-70px" }}
            transition={{ duration: 0.65, delay, ease: EASE }}
        >
            {children}
        </motion.div>
    );
}

export function SectionHeading({ chapter, eyebrow, title, description, testid }) {
    return (
        <div className="mb-12 max-w-3xl lg:mb-16" data-testid={testid}>
            <Reveal>
                <p className="mb-4 font-mono text-xs font-medium uppercase tracking-[0.3em] text-sky-400">
                    {chapter} — {eyebrow}
                </p>
            </Reveal>
            <Reveal delay={0.08}>
                <h2 className="font-display text-3xl font-bold tracking-tight text-slate-50 sm:text-4xl lg:text-5xl">
                    {title}
                </h2>
            </Reveal>
            {description && (
                <Reveal delay={0.16}>
                    <p className="mt-5 text-base leading-relaxed text-slate-400 sm:text-lg">{description}</p>
                </Reveal>
            )}
        </div>
    );
}
